import React from 'react';
import { User, UserCheck, MessageSquare } from 'lucide-react';
import { formatTimeStable } from './utils/formatUtils';
import { getStatusColor, getVarianceColor } from './utils/styleUtils';

const WorklogRow = ({ log }) => {
  const hasAuthor = log.author && log.author !== 'null';
  const hasAssignee = log.issue_assignee && log.issue_assignee !== 'null';
  const hasComment = log.comment && log.comment.trim() !== '';
  
  return (
    <tr className="hover:bg-gray-50 dark:hover:bg-slate-700/50">
      <td className="px-3 sm:px-4 py-3 text-sm">
        <div className="flex items-center gap-2 mb-1 flex-wrap">
        <div className="font-medium text-gray-900 dark:text-slate-100">{log.issue_key}</div>
          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs flex-shrink-0 ${getStatusColor(log.issue_status)}`}>
            {log.issue_status}
          </span>
        </div>
        <div className="text-gray-600 dark:text-slate-400 text-xs truncate max-w-xs" title={log.issue_summary}>
          {log.issue_summary}
        </div>
      </td>
      <td className="px-3 sm:px-4 py-3 text-sm">
        <div className="flex flex-col space-y-1">
          <div className="flex items-center">
            <User className="w-3 h-3 text-blue-500 mr-1 flex-shrink-0" />
            <span className="text-blue-600 dark:text-blue-400 font-medium truncate">
              {hasAuthor ? log.author : 'Unknown'}
            </span>
          </div>
          <div className="flex items-center">
            <UserCheck className="w-3 h-3 text-green-500 mr-1 flex-shrink-0" />
            <span className="text-green-600 dark:text-green-400 truncate">
              {hasAssignee ? log.issue_assignee : 'Unassigned'}
            </span>
          </div>
        </div>
      </td>
      <td className="px-3 sm:px-4 py-3 text-sm">
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-gray-100 text-gray-800 dark:bg-slate-700 dark:text-slate-200">
          {log.issue_project_name || log.issue_project_key}
        </span>
      </td>
      <td className="px-3 sm:px-4 py-3 text-sm whitespace-nowrap">
        <span className="font-medium text-blue-600 dark:text-blue-400">{log.loggedHours}h</span>
      </td>
      <td className="px-3 sm:px-4 py-3 text-sm text-gray-600 dark:text-slate-400 whitespace-nowrap">{log.estimatedHours}h</td>
      <td className="px-3 sm:px-4 py-3 text-sm text-gray-600 dark:text-slate-400 whitespace-nowrap">
        <div>{log.loggedDate}</div>
        <div className="text-xs text-gray-500 dark:text-slate-500">{formatTimeStable(log.started)}</div>
      </td>
      <td className={`px-3 sm:px-4 py-3 text-sm font-medium whitespace-nowrap ${getVarianceColor(log.variance)}`}>
        {log.variance > 0 ? '+' : ''}{log.variance}h
      </td>
      <td className="px-3 sm:px-4 py-3 text-sm">
        {hasComment ? (
          <div className="flex items-start">
            <MessageSquare className="w-3 h-3 text-gray-400 dark:text-slate-500 mr-1 mt-0.5 flex-shrink-0" />
            <div className="text-gray-600 dark:text-slate-400 text-xs max-w-xs">
              <div className="truncate" title={log.comment}>
                {log.comment}
              </div>
            </div>
          </div>
        ) : (
          <span className="text-gray-400 dark:text-slate-500 text-xs">No description</span>
        )}
      </td>
    </tr>
  );
};

export default WorklogRow;

